import { GET_PROMO_OFFER_MAIL } from "../constants";

const initialState = [];

export const requestList = (state = initialState, { type, payload }) => {
    switch (type) {
        
        case GET_PROMO_OFFER_MAIL: {
            state = [...payload];
            return state;
        }
        default: {
            return state
        }
    }
};